export const RESERVAS_CONFIG = {
  DIAS_MINIMOS_PARA_CREAR_RESERVA: 8,
  FECHA_MAXIMA_RESERVA: '2026-12-31',
}
